module.exports = __webpack_public_path__ + "static/media/partnerships-bg-sm.68a46295.png";